(function ($) {
  'use strict';

  /**
   * Ingredients - Slider + Popup + Nested Sliders
   * ---
   * - Card Slider
   * - Popup Buttons
   * - Pagination within popup
   * - Category slider within popup
   */

  // RTL Helpers
  var is_rtl = document.dir === 'rtl';
  var slider_dir = is_rtl ? 'rtl' : 'ltr';


  /**
   * Prep Popups
   * ---
   * To avoid duplicate popups,
   * Copy popup els _outside_ of slides _before_ init'n the slider
   */

  var $ingredient_card_popups_orig = $('.white-popup--ingredient');

  $ingredient_card_popups_orig.each(function () {
    var $this = $(this);
    $this.appendTo( $this.closest('.js-ingredients-cards') );
  });


  /**
   * Card Slider - Init first, before setting up button popup controls
   */

  var slider_ingredients = document.querySelectorAll( '.js-ingredients-cards' );

  if ( slider_ingredients && slider_ingredients.length ) {
    slider_ingredients.forEach(function ( this_slider ) {

      var this_slides = this_slider.querySelectorAll( '.splide__slide' );
      var slider_type = 'slide';
      var slider_arrows = false;
      var is_disabled = true;

      if ( this_slides.length >= 3 ) {
        slider_type = 'loop';
        slider_arrows = true;
        is_disabled = false;
      }

      new Splide( this_slider, {
        // Slider Config
        type: slider_type,
        arrows: slider_arrows,
        perPage: 1,
        focus: 'center',
        autoWidth: true,
        // Styles
        gap: '1.25rem',
        padding: '4.375rem',
        direction: slider_dir,
        destroy: is_disabled,
        // MQ Breakpoints (Max-Width, from mobile -> desktop)
        breakpoints: {
          760: {
            destroy: false,
            type: 'loop',
            arrows: true,
          },
        },
      }).mount();
    });
  }


  /**
   * Popups - Init after slider
   */

  var $ingredient_popup_buttons = $('.js-ingredient-popup');

  // Init Popup Buttons
  if ( $ingredient_popup_buttons.length ) {
    $ingredient_popup_buttons.magnificPopup({
      type: 'inline',
      midClick: true,
      gallery: { enabled: true },
    });
  }


  /**
   * Pagination
   */

  var $popup_box = $('.white-popup--ingredient');

  // Setup pagination markup
  if ( $popup_box.length ) {
    var pagination_item_label = $('.popup-ingredient-pagination').attr( 'data-item-label' );

    $popup_box.each(function ( index ) {
      var this_item_label = pagination_item_label + ' ' + index;

      $('.popup-ingredient-pagination ul').append( ''
        + '<li>'
        + '<button class="js-magnific-slide" data-slide-number="'
        + index
        + '">'
        + '<span class="vh">'
        + this_item_label
        + '</span>'
        + '</button>'
        + '</li>'
      );
    });

    // Set active class
    $('.popup-ingredient-pagination ul').each(function ( index ) {
      $(this).find( '> li' )
        .eq( index )
        .find( '.js-magnific-slide' )
        .addClass( 'is-active' );
    });
  }

  // Pagination Buttons
  $(document).on( 'click', '.js-magnific-slide', function () {
    // Get slide number - `data()` parses as int
    var slider_number = $(this).data( 'slide-number' );

    $ingredient_popup_buttons.magnificPopup(
      'goTo',
      slider_number
    );
  });


  /**
   * Slider - Inside popup
   */

  var ingredient_menu_category_slider = document.querySelectorAll( '.js-slider-ingredient-items' );

  if ( ingredient_menu_category_slider && ingredient_menu_category_slider.length ) {
    ingredient_menu_category_slider.forEach(function ( this_slider ) {
      new Splide( this_slider, {
        // Slider Config
        perPage: 2,
        perMove: 1,
        arrows: true,
        pagination: false,
        // Styles
        gap: '0.75rem',
        padding: '2rem',
        direction: slider_dir,
        breakpoints: {
          480: {
            perPage: 1,
          },
        },
      }).mount();
    });
  }

})(jQuery);
